export const isWordCountSupported = typeof Intl?.Segmenter !== 'undefined'
